import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { PasstObtjetivoModel } from 'src/app/models/passt/PasstObtjetivoModel';

@Component({
  templateUrl: './passt-objetivo-registrar-dialog.component.html',
  styleUrls: ['./passt-objetivo-registrar-dialog.component.css']
})
export class PasstObjetivoRegistrarDialogComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<PasstObjetivoRegistrarDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public model: PasstObtjetivoModel) { }

  ngOnInit(): void {
  }
  onNoClick(): void {
    this.dialogRef.close();
  } 
}
